import React, { useEffect } from 'react';

// import Layout from "../components/layout";
// import Seo from "../components/seo";

const NotFoundPage = () => {
  useEffect(() => {
    window.location.replace("https://billygraham.org");
  }, []);
  return <p>Redirecting ...</p>;
};

export default NotFoundPage;